import { DocumentHead, PageTemplate } from 'lib/components';
import React, { useMemo } from 'react';
import { PreLoader } from './PreLoader';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Dashboard = () => (
  <>
    <DocumentHead title="Reports Dashboard" />
    <PageTemplate main={<Wrapper />} />
  </>
);
